import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=5a21d4d9&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=js"
export * from "./withdraw.vue?vue&type=script&lang=js"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=5a21d4d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a21d4d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a21d4d9')) {
      api.createRecord('5a21d4d9', component.options)
    } else {
      api.reload('5a21d4d9', component.options)
    }
    module.hot.accept("./withdraw.vue?vue&type=template&id=5a21d4d9&scoped=true", function () {
      api.rerender('5a21d4d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/withdraw.vue"
export default component.exports